import React, { useCallback, useEffect, useMemo, useState } from "react";
import UserService from "../../../../services/user/UserService";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";

const ModalAddEditEvaluasi = ({ showEvaluasiTeknis, handleCloseEvaluasiTeknis, dataPrimer, dataEvaluasi, setListEvaluasi, isEdit, jenisIzin }) => {
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    const [valueTglEvaluasi, setValueTglEvaluasi] = useState(null)
    const [valueJenisGradeOpt, setValueJenisGradeOpt] = useState(null)

    async function loadOptionJenisGrade(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listJenisGrade(jenisIzin, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeJenisGrade = e => {
        setValueJenisGradeOpt(e)
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawai = e => {
        setValuePegawaiOpt(e)
    }
    const handleChangeTglEvaluasi = e => {
        setValueTglEvaluasi(e.target.value)
    }
    const handleChangeCatatan = e => {
        setValueCatatan(e.target.value)
    }

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataEvaluasi?.nipEvaluator) {
            return
        }
        try {
            setValueCatatan(dataEvaluasi?.catatan)
            setValueTglEvaluasi(dataEvaluasi?.tglEvaluasi)

            const resPegawai = await userService.getPegawaiById(dataEvaluasi.nipEvaluator)
            setValuePegawaiOpt(resPegawai.data)

            const resJenisGrade = await pbumkuService.getJenisGrade(jenisIzin, dataEvaluasi?.kodeGrade)
            setValueJenisGradeOpt(resJenisGrade?.data)
        } catch (error) {

        }
    }, [userService, dataPrimer, dataEvaluasi, jenisIzin, pbumkuService])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPrimer, fetchAllData])

    const handleClickSimpan = () => {
        const jsonEvaluasi = {
            ...dataEvaluasi,
            nipEvaluator: valuePegawaiOpt.nip,
            nmEvaluator: valuePegawaiOpt.nama,
            tglEvaluasi: valueTglEvaluasi,
            catatan: valueCatatan,
            createdBy: localStorage.getItem("userId"),
            createdDate: new Date(),
            kodeGrade: valueJenisGradeOpt.kodeGrade
        }
        setListEvaluasi(prevList => {
            const index = prevList.findIndex(item => item.nomorAju === dataPrimer.nomorAju && item.nipEvaluator === valuePegawaiOpt.nip)
            let newList
            if (index !== -1) {
                newList = [...prevList]
                newList[index] = { ...jsonEvaluasi }
            } else {
                newList = [...prevList, jsonEvaluasi]
            }
            return newList.map((item, idx) => ({ ...item, nomorAju: dataPrimer.nomorAju }))
        })
        handleCloseEvaluasiTeknis()
    }

    return (
        <>
            <Modal
                show={showEvaluasiTeknis}
                onHide={handleCloseEvaluasiTeknis}
                size="lg"
                centered
            >
                <Modal.Header><Modal.Title><h5>Reviu Tim Teknis {jenisIzin}</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan Tim Teknis</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" rows={5} placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={handleChangeCatatan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">
                                        {(jenisIzin === 'CPIB' || jenisIzin === 'CBIB' || jenisIzin === 'CPIBK') && <>Grade</>}
                                        {(jenisIzin === 'CPOIB' || jenisIzin === 'CDOIB') && <>Kategori</>}
                                        {(jenisIzin === 'CPPIB') && <>Tingkat Pengawasan</>}
                                    </Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisGrade}
                                            value={valueJenisGradeOpt}
                                            getOptionValue={(option) => option.kodeGrade}
                                            getOptionLabel={(option) => option.kodeGrade + ' - ' + option.uraianGrade}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisGrade}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Evaluasi</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="date" placeholder="Tanggal" className="form-control-sm" value={valueTglEvaluasi} onChange={handleChangeTglEvaluasi} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Evaluator</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPegawai}
                                            value={valuePegawaiOpt}
                                            getOptionValue={(option) => option.nip}
                                            getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangePegawai}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseEvaluasiTeknis}>Batal</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalAddEditEvaluasi